import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { getBadgeConfig } from './verificationUtils';
import css from './VerifiedBadge.module.css';

/**
 * VerifiedBadge — shows verification badge on user profiles.
 *
 * Usage (in ProfilePage, user card):
 *   {features.userVerification && isVerified(user) && (
 *     <VerifiedBadge type={getVerificationDetails(user)?.type} />
 *   )}
 */
const VerifiedBadge = ({ type, showLabel, className }) => {
  const config = getBadgeConfig(type || 'identity');

  return (
    <span
      className={classNames(css.badge, className)}
      style={{ color: config.color, borderColor: config.color + '33' }}
      title={config.label}
    >
      <span className={css.emoji}>{config.emoji}</span>
      {showLabel && <span className={css.label}>{config.label}</span>}
    </span>
  );
};

VerifiedBadge.defaultProps = { type: 'identity', showLabel: false, className: null };
VerifiedBadge.propTypes = { type: string, className: string };

export default VerifiedBadge;
